import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AppService } from '../../../app.service';
@Component({
  selector: 'navbar-top',
  templateUrl: './navbar-top.component.html',
  styleUrls: ['../../../app.component.css']
})
export class NavbarTopComponent {
    UCUri: string;
    GETUri: string;
    IdentityServerUri: string;
    TTLogoImagePath: string = 'api/Application/DealershipLogo/';
    userName: string;
    constructor(private _appService: AppService) {
    }
    ngOnInit() {
        //this._appService.getApplicationConfigValue("IdentityServerUri").subscribe(result => { this.IdentityServerUri = result });
        this._appService.getApplicationConfigValue("UCUri").subscribe(result => { this.UCUri = result });
        this._appService.getApplicationConfigValue("GETUri").subscribe(result => { this.GETUri = result });
        this._appService.GetLoggedInUserName().subscribe(result => { this.userName = result;  });
    }

    toggleMenu() {
        //this._appService.toggleMenuVisible();
    }
}
